import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  CardCvcElement,
} from '@stripe/react-stripe-js';

const CardCvcInput = (props) => {
  const { t } = useTranslation();
  const {
  } = props;
  const [error, setError] = useState(null)

  return (
    <div>
      <div
        className={`px-[11px] py-[7px] h-[32px] bg-white rounded border border-solid border-[#d9d9d9] ${error ? 'border-danger' : 'hover:border-primary'}`}
      >
        <CardCvcElement
          options={{
            showIcon: true,
            style: {
              base: {
                fontSize: '14px',
                color: "rgba(0, 0, 0, 0.88)",
                fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
                '::placeholder': {
                  color: '#8c8c8c',
                },
              },
              invalid: {
                color: '#F54F64',
              },
            },
          }}
          onChange={(e) => {
            if (e.empty) {
              setError({ code: 'required' })
            } else if (e.error) {
              setError(e.error);
            } else {
              setError(null);
            }
          }} 
        />
      </div>
      {
        error?.code && <p className="text-xs text-danger">
          {t(`validation.${error.code}`, { name: t('common.cvc') })}
        </p>
      }
    </div>
  );
}

export default CardCvcInput;